<template>
  <div class="personal-profile-form">
    <h4 class="section-title">1 填写你的个人画像</h4>
    
    <!-- 学习基础 -->
    <div class="form-group">
      <h5 class="group-title">学习基础</h5>
      
      <div class="form-item">
        <label class="form-label">高考预估分数段</label>
        <el-select v-model="formData.scoreRange" placeholder="请选择" size="small" class="full-width" @change="handleFormChange">
          <el-option label="400-450分" value="400-450"></el-option>
          <el-option label="450-500分" value="450-500"></el-option>
          <el-option label="500-550分" value="500-550"></el-option>
          <el-option label="550-600分" value="550-600"></el-option>
          <el-option label="600分以上" value="600+"></el-option>
        </el-select>
      </div>
      
      <div class="form-item">
        <label class="form-label">优势学科（可多选）</label>
        <div class="inline-checkbox-group">
          <el-checkbox-group v-model="formData.subjects" @change="handleFormChange">
            <el-checkbox label="物理">物理</el-checkbox>
            <el-checkbox label="数学">数学</el-checkbox>
            <el-checkbox label="化学">化学</el-checkbox>
            <el-checkbox label="生物">生物</el-checkbox>
            <el-checkbox label="语文">语文</el-checkbox>
            <el-checkbox label="英语">英语</el-checkbox>
            <el-checkbox label="历史">历史</el-checkbox>
            <el-checkbox label="地理">地理</el-checkbox>
            <el-checkbox label="政治">政治</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    
    <!-- 兴趣特质 -->
    <div class="form-group">
      <h5 class="group-title">兴趣特质</h5>
      
      <div class="form-item">
        <label class="form-label">职业兴趣类型</label>
        <el-select v-model="formData.careerType" placeholder="请选择" size="small" class="full-width" @change="handleFormChange">
          <el-option label="现实型" value="realistic"></el-option>
          <el-option label="研究型" value="investigative"></el-option>
          <el-option label="艺术型" value="artistic"></el-option>
          <el-option label="社会型" value="social"></el-option>
          <el-option label="企业型" value="enterprising"></el-option>
          <el-option label="常规型" value="conventional"></el-option>
        </el-select>
      </div>
      
      <div class="form-item">
        <label class="form-label">排斥领域（可多选）</label>
        <div class="inline-checkbox-group">
          <el-checkbox-group v-model="formData.excludeFields" @change="handleFormChange">
            <el-checkbox label="医疗">医疗</el-checkbox>
            <el-checkbox label="工程">工程</el-checkbox>
            <el-checkbox label="艺术">艺术</el-checkbox>
            <el-checkbox label="教育">教育</el-checkbox>
            <el-checkbox label="金融">金融</el-checkbox>
            <el-checkbox label="IT">IT</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    
    <!-- 家庭资源 -->
    <div class="form-group">
      <h5 class="group-title">家庭资源</h5>
      
      <div class="form-item">
        <label class="form-label">家庭行业资源</label>
        <el-select v-model="formData.familyResource" placeholder="请选择" size="small" class="full-width" @change="handleFormChange">
          <el-option label="科技/IT" value="tech"></el-option>
          <el-option label="金融/经济" value="finance"></el-option>
          <el-option label="教育/科研" value="education"></el-option>
          <el-option label="医疗/健康" value="medical"></el-option>
          <el-option label="政府/公共服务" value="government"></el-option>
          <el-option label="商业/贸易" value="business"></el-option>
          <el-option label="制造业" value="manufacturing"></el-option>
          <el-option label="媒体/文化" value="media"></el-option>
        </el-select>
      </div>
      
      <div class="form-item">
        <label class="form-label">经济支撑能力</label>
        <el-radio-group v-model="formData.economicSupport" size="small" @change="handleFormChange">
          <el-radio label="high">高</el-radio>
          <el-radio label="medium">中</el-radio>
          <el-radio label="low">低</el-radio>
        </el-radio-group>
      </div>
    </div>
    
    <!-- 地域与风险 -->
    <div class="form-group">
      <h5 class="group-title">地域与风险</h5>
      
      <div class="form-item">
        <label class="form-label">目标就业地（可多选）</label>
        <div class="inline-checkbox-group">
          <el-checkbox-group v-model="formData.targetRegions" @change="handleFormChange">
            <el-checkbox label="广东">广东</el-checkbox>
            <el-checkbox label="北京">北京</el-checkbox>
            <el-checkbox label="上海">上海</el-checkbox>
            <el-checkbox label="江苏">江苏</el-checkbox>
            <el-checkbox label="浙江">浙江</el-checkbox>
            <el-checkbox label="四川">四川</el-checkbox>
            <el-checkbox label="湖北">湖北</el-checkbox>
            <el-checkbox label="湖南">湖南</el-checkbox>
            <el-checkbox label="其他">其他</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      
      <div class="form-item">
        <label class="form-label">风险偏好</label>
        <el-radio-group v-model="formData.riskPreference" size="small" @change="handleFormChange">
          <el-radio label="high">高风险高回报</el-radio>
          <el-radio label="medium">中等风险</el-radio>
          <el-radio label="low">低风险稳定</el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalProfileForm',
  props: {
    value: {
      type: Object,
      default: () => ({
        scoreRange: '',
        subjects: [],
        careerType: '',
        excludeFields: [],
        familyResource: '',
        economicSupport: 'medium',
        targetRegions: [],
        riskPreference: 'medium'
      })
    }
  },
  data() {
    return {
      formData: { ...this.value }
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.formData = { ...newVal }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleFormChange() {
      this.$emit('input', this.formData)
      this.$emit('change', this.formData)
    },
    resetForm() {
      this.formData = {
        scoreRange: '',
        subjects: [],
        careerType: '',
        excludeFields: [],
        familyResource: '',
        economicSupport: 'medium',
        targetRegions: [],
        riskPreference: 'medium'
      }
      this.handleFormChange()
    },
    validateForm() {
      return this.formData.scoreRange && 
             this.formData.subjects.length > 0 && 
             this.formData.careerType && 
             this.formData.targetRegions.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-profile-form {
  .section-title {
    font-size: 15px;
    font-weight: 700;
    color: #000;
    margin-bottom: 20px;
    padding-left: 0;
  }
}

.form-group {
  margin-bottom: 24px;
}

.group-title {
  font-size: 14px;
  font-weight: 700;
  color: #000;
  margin: 0 0 12px 0;
}

.form-item {
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.form-label {
  display: block;
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
  font-weight: 400;
}

.full-width {
  width: 100%;
}

.inline-checkbox-group {
  ::v-deep .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
  }
  
  ::v-deep .el-checkbox {
    margin-right: 0;
  }
  
  ::v-deep .el-checkbox__label {
    font-size: 13px;
    padding-left: 6px;
  }
}

::v-deep .el-radio-group {
  display: flex;
  gap: 16px;
}

::v-deep .el-radio__label {
  font-size: 13px;
  padding-left: 6px;
}

::v-deep .el-select {
  width: 100%;
}
</style>
